import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { FaPaperPlane, FaCheckCircle } from 'react-icons/fa';
import './Newsletter.css';

export default function Newsletter() {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (email) {
      setSubmitted(true);
      setEmail('');
    }
  };

  return (
    <section className="newsletter-section">
      <div className="newsletter-bg" />
      <div className="container">
        <motion.div
          className="newsletter-inner"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
        >
          <div className="newsletter-text">
            <span className="section-badge" style={{ color: 'var(--primary-light)' }}>Exclusive Offers</span>
            <h2 style={{ color: 'var(--white)', fontFamily: 'var(--font-heading)', fontSize: 'clamp(1.8rem, 3vw, 2.5rem)', marginBottom: '12px' }}>
              Stay in the Loop
            </h2>
            <p style={{ color: 'rgba(255,255,255,0.7)', maxWidth: '480px', lineHeight: 1.8 }}>
              Subscribe to our newsletter and be the first to receive exclusive offers,
              seasonal packages, and luxury travel inspiration.
            </p>
          </div>

          <div className="newsletter-form-wrap">
            {submitted ? (
              <motion.div
                className="newsletter-success"
                initial={{ opacity: 0, scale: 0.9 }}
                animate={{ opacity: 1, scale: 1 }}
              >
                <FaCheckCircle />
                <p>Thank you! You're now on our exclusive list.</p>
              </motion.div>
            ) : (
              <form onSubmit={handleSubmit} className="newsletter-form-row">
                <input
                  type="email"
                  placeholder="Enter your email address"
                  value={email}
                  onChange={e => setEmail(e.target.value)}
                  required
                />
                <button type="submit" className="btn btn-primary">
                  <FaPaperPlane /> Subscribe
                </button>
              </form>
            )}
            <p className="newsletter-disclaimer">
              We respect your privacy. Unsubscribe at any time.
            </p>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
